import React from 'react';
import RIEBase from 'components/core/editable/RIEBase';
import SecondsInput from 'components/core/editable/SecondsInput';
import Constants from 'utils/Constants';

export default class RIESecondsInput extends RIEBase {

    onChange = (fieldPath, value) => {
        if (!value) {
            value = 0; // if the user deleted the value, make sure it defaults to zero
        }
        this.setState({ newValue: value });
    };

    highlightComponentText = () => {
        this.secondsInputComponent.highlightComponentText();
    };

    renderEditingComponent = () => {
        const secondsInputRefFunction = (component) => { this.secondsInputComponent = component; };

        return (
            <SecondsInput
                value={this.props.value}
                className={this.makeClassString()}
                editProps={this.props.editProps}
                onChange={this.onChange}
                ref={secondsInputRefFunction}
                units={this.props.units}
            />
        );
    };

    getMinWidth = () => {
        return '275px';
    };

    renderReadComponent = () => {
        const value = this.getNewValue();
        let annotation = null;

        // we have to explicitly check for 0 value
        if (value === 0) {
            annotation = `${value} seconds`;

        } else if (value) {
            annotation = `${value} seconds ${Constants.getSecondsDescriptiveLabel(value)}`;
        }
        // add onFocus back in order to go into edit mode via tab key then refactor RIE base so context menu will still work
        // onFocus={this.startEditing}
        return (
            <span
                tabIndex="0"
                className={this.makeClassString()}
                onClick={this.startEditing}
                {...this.props.defaultProps}
            >
                {annotation}
            </span>
        );
    };
}



// WEBPACK FOOTER //
// ./src/components/core/editable/RIESecondsInput.js